module.exports = __webpack_public_path__ + "media/packs/users/img/footer/fa-dollar-solid-c602f61c9e693900b96e48710af4075b.svg";